import { Record, Map } from 'immutable'
import { record as IntegrationRecord } from 'data/integrations'

const ApplicationRecord = Record(
  {
    id: '',
    isInstalled: false,
    name: '',
    clientId: '',
    labels: Map(),
    photoURL: '',
    integration: IntegrationRecord(),
    installationUrls: Map(),
    features: [],
    description: '',
  },
  'Application'
)

export default ApplicationRecord
